import { cn } from '@/utils/styles';

import React, { useEffect, useRef } from 'react';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';

function OtherOptionField({
	showCheckbox,
	hideIcon = false,
	selected,
	disabled,
	onSelect,
	onInputChange,
	inputValue,
	defaultInputValue,
}: {
	showCheckbox?: boolean;
	hideIcon?: boolean;
	selected: boolean;
	disabled?: boolean;
	onSelect?: (checked: boolean) => void;
	onInputChange?: (value: string) => void;
	inputValue?: string;
	defaultInputValue?: string;
}) {
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (selected) {
			inputRef.current?.focus();
		}
	}, [selected]);

	return (
		<div className="flex w-full items-center gap-3">
			<Button
				variant={'ghost'}
				className={cn(
					'flex w-fit max-w-full cursor-default items-center justify-start gap-3 p-3 px-0 hover:bg-transparent',
					!disabled ? 'cursor-pointer' : ''
				)}
				onClick={() => onSelect?.(!selected)}
			>
				{hideIcon ? null : showCheckbox ? (
					<Checkbox
						className={cn(
							'h-5 w-5 rounded-[2px] border-2 disabled:opacity-100',
							disabled && 'cursor-not-allowed border-gray-400'
						)}
						disabled={disabled}
						checked={selected}
						onCheckedChange={onSelect}
						onClick={(e) => e.stopPropagation()}
					/>
				) : (
					<span
						className={cn(
							'h-5 w-5 rounded-full border-2 border-primary p-1',
							disabled && 'cursor-not-allowed border-gray-400'
						)}
					>
						{selected && <span className="flex h-full w-full rounded-full bg-primary" />}
					</span>
				)}
				<p
					className={cn(
						'text-base font-normal leading-6',
						disabled && 'cursor-default text-gray-400'
					)}
				>
					Other{disabled ? '...' : ':'}
				</p>
			</Button>

			{disabled ? null : (
				<Input
					ref={inputRef}
					className="w-full rounded-none border-b border-l-0 border-r-0 border-t-0 text-base outline-none focus-visible:border-primary focus-visible:shadow-none focus-visible:shadow-white focus-visible:ring-0"
					disabled={disabled}
					value={inputValue}
					defaultValue={defaultInputValue}
					onChange={(e) => {
						if (inputValue && !e.target.value) onSelect?.(false);
						else if (!inputValue && e.target.value) onSelect?.(true);

						onInputChange?.(e.target.value);
					}}
				/>
			)}
		</div>
	);
}

export default OtherOptionField;
